// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__M3rI7","wrapper":"Checkbox_wrapper__+u5wU","input":"Checkbox_input__O4Rwg","icon":"Checkbox_icon__W2iiL","true":"Checkbox_true__-3g+u"};